import { AuthLayout } from '@/components/auth/AuthLayout';
import { AcceptInviteForm } from '@/components/auth/AcceptInviteForm';

export const AcceptInvite = () => (
  <AuthLayout>
    <AcceptInviteForm />
  </AuthLayout>
);
